<template>
  <popup class="supermarket-summary-container">
    <template v-slot:content>
      <div v-on:click="close">
        <img class="close-action-icon" :src="require('@/assets/icons/close-white.svg')">
      </div>
      <supermarket-summary-core :supermarket-graph-history="supermarketGraphHistory" :supermarket-summary="supermarketSummary"
                                :improvement="improvement" :benchmark-type="benchmarkType"></supermarket-summary-core>
      <div class="button-area">
        <share-button title="לשתף עם חבר או חברה" filename="supermarket-summary" share-name="SupermarketSummary"
                      :share-component="shareComponent" :share-component-props="shareComponentProps" :show-popup="false"
                      :segment-extra-props="segmentExtraProps" v-slot="slotProps">
          <riseup-button variant="primary"
                         size="slim"
                         title="לשתף עם חבר או חברה"
                         :action="slotProps.onClick"
                         :loading="slotProps.loading"/>
        </share-button>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import ShareButton from '@/base-components/share/ShareButton';
import SupermarketSummaryCore
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/supermarket-summary/SupermarketSummaryCore';
import SupermarketSummaryAsset
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/supermarket-summary/SupermarketSummaryAsset';
import TransactionDisplayUtils
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/TransactionDisplayUtils';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'SupermarketSummary',
  mixins: [TransactionDisplayUtils],
  components: {
    Popup: BaseUI.Popup,
    SupermarketSummaryCore,
    ShareButton,
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    this.loading = true;
    await this.fetchSupermarketSummary();
    Segment.trackUserGot('SupermarketSummaryOpenedV2', this.segmentExtraProps);
    this.loading = false;
  },
  computed: {
    ...mapGetters('cashflowView', ['supermarketGraphHistory']),
    ...mapGetters('supermarketSummary', ['benchmarkType', 'improvement']),
    ...mapState('supermarketSummary', ['supermarketSummary']),
    segmentExtraProps() {
      return {
        benchmarkType: this.benchmarkType,
      };
    },
    shareComponent() {
      return SupermarketSummaryAsset;
    },
    shareComponentProps() {
      return {
        supermarketGraphHistory: this.supermarketGraphHistory,
        supermarketSummary: this.supermarketSummary,
        improvement: this.improvement,
        benchmarkType: this.benchmarkType,
      };
    },
  },
  methods: {
    ...mapActions('supermarketSummary', ['fetchSupermarketSummary']),
    close() {
      Segment.trackUserInteraction('SupermarketSummaryClosed', this.segmentData);
      this.$emit('close');
    },
  },
};

</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../../../scss/mixins';

.supermarket-summary-container.popup {
  position: relative;

  .top {
    padding: 0;
    .action-icon {
      display: none;
    }
    .text-wrapper .content {
      margin: 0;
    }
  }

  .close-action-icon {
    position: absolute;
    left: 9px;
    top: 9px;
    height: 24px;
    cursor: pointer;
  }

  .button-area {
    padding: 18px;
  }
}

</style>
